/// <amd-module name="Search/Shared/Components/TimeoutComponent/TimeoutComponent" />
import * as React from "react";
import { TimerManagement } from "VSS/Core/TimerManagement";
import { ITimeoutComponentProps, ITimeoutComponentState } from "./TimeoutComponent.Props"

export class TimeoutComponent extends React.Component<ITimeoutComponentProps, ITimeoutComponentState> {
    private timerManagement: TimerManagement;

    constructor(props: ITimeoutComponentProps) {
        super(props);
        this.state = { renderInner: false };
        this.timerManagement = new TimerManagement();
    }

    public render(): JSX.Element {
        const { renderInner } = this.state;

        return renderInner ? (
            <>
                {
                    this.props.children
                }
            </>
        ) : <div />;
    }

    public componentDidMount(): void {
        this.timerManagement.setTimeout(() => {
            this.setState({ renderInner: true });
        }, this.props.timeout);
    }

    public componentWillUnmount(): void {
        this.timerManagement.dispose();
    }
}
